export default __webpack_public_path__ + "static/media/non_login_user.9817a98a.svg";